import { useState, useEffect } from "react";
import ModalBox from "../../components/ModalBox/ModalBox";
import "./MemoryTest.css";
import { initialModal, endGameModal } from "./Modals";
import ActivityHeader from "../../components/ActivityHeader/ActivityHeader";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import { WORDS } from "./words";
import { trackGameStart } from "../../utils/trackEvents";

const WORD_COUNT = 10;

function getRandomWords(count) {
  const uniqueWords = Array.from(new Set(WORDS));
  const shuffled = uniqueWords.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

function MemoryTest() {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isGameStarted, setIsGameStarted] = useState(false);
  const [modalContent, setModalContent] = useState(initialModal());
  const [words, setWords] = useState([]);
  const [stage, setStage] = useState(1); // 1 = view, 2 = input
  const [timeLeft, setTimeLeft] = useState(15);
  const [inputs, setInputs] = useState(Array(WORD_COUNT).fill(""));

  useEffect(() => {
    if (!isGameStarted) return;

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        const next = prev - 1;
        if (next === 0) {
          clearInterval(interval);
          if (stage === 1) {
            setStage(2);
            setTimeLeft(45);
          } else {
            const missedWords = words.filter(
              (word) =>
                !inputs.some(
                  (input) => input.toLowerCase() === word.toLowerCase()
                )
            );
            setModalContent(
              endGameModal(WORD_COUNT - missedWords.length, missedWords)
            );
            setIsModalOpen(true);
            setIsGameStarted(false);
          }
        }
        return next;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isGameStarted, stage, words, inputs]);

  function handleStart() {
    setWords(getRandomWords(WORD_COUNT));
    setInputs(Array(WORD_COUNT).fill(""));
    setTimeLeft(12);
    setStage(1);
    setIsGameStarted(true);
    setIsModalOpen(false);
    trackGameStart("MemoryTest", "Started");
  }

  function handleInputChange(index, value) {
    const updated = [...inputs];
    updated[index] = value;
    setInputs(updated);
  }

  function handleSubmit() {
    const missedWords = words.filter(
      (word) =>
        !inputs.some((input) => input.toLowerCase() === word.toLowerCase())
    );
    setModalContent(endGameModal(WORD_COUNT - missedWords.length, missedWords));
    setIsModalOpen(true);
    setIsGameStarted(false);
  }

  return (
    <div className="memoryTest-main">
      <ActivityHeader>Time: {timeLeft}s</ActivityHeader>

      <div className="memoryTest-contents">
        <div className="memoryTest-words">
          {stage === 1
            ? words.map((word, i) => (
                <span key={i} className="word">
                  {word}
                </span>
              ))
            : inputs.map((val, i) => (
                <input
                  key={i}
                  type="text"
                  value={val}
                  onChange={(e) => handleInputChange(i, e.target.value)}
                  className="word"
                />
              ))}
        </div>
        {stage === 2 && (
          <div className="memoryTest-submit">
            <PrimaryButton onClick={handleSubmit}>Submit</PrimaryButton>
          </div>
        )}
      </div>

      <ModalBox
        isOpen={isModalOpen}
        title={modalContent.title}
        description={modalContent.description}
        buttonText={modalContent.buttonText}
        buttonType={modalContent.buttonType}
        onClose={handleStart}
      />
    </div>
  );
}

export default MemoryTest;
